import React, {useRef, useState} from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet';
import './live.css'

const Live = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  
  const castrUrl = 'https://player.castr.com/live_7dc04e3094ae11efb2f551bac7a58814';

  return (
    <div className="live-page">
      <Helmet>
        <title>Live TV | Yorke TV Live</title>
        <meta name="description" content="Watch Yorke TV Live Streaming" />
        <meta name="keywords" content="Yorke TV Live, Live Streaming, Channel 7" />
        <meta name="author" content="Groupe Nduom Station Based In UK" />
        <link rel="canonical" href="https://www.yorketv.com/live" />
      </Helmet>

      <Container>
        {/* Page Header */}
        <div className="live-header">
          <h6 className="live-subtitle">Watch Now</h6>
          <h1 className="live-title">Live TV</h1>
          <p className="live-description">
            Stream live television and enjoy channel shows from the comfort of your home
          </p>
        </div>

        {/* Live Player Section */}
        <div className="live-player-section">
          <div className="live-player-wrapper">
            <div className="live-status">
              <span className="live-indicator">
                <span className="live-dot"></span>
                LIVE
              </span>
              <span className="live-channel-name">YorkeTV</span>
            </div>
            
            <div className="video-container-live">
              <iframe 
                src={castrUrl}
                className="live-video-player"
                allowFullScreen
                frameBorder="0"
                title="YorkeTV Live Stream"
                allow="autoplay; fullscreen; picture-in-picture"
              ></iframe>
            </div>

            <div className="live-player-info">
              <h3 className="live-player-title">YorkeTV Live Stream</h3>
              <p className="live-player-description">
                Watch our live broadcast 24/7. Stay connected with the latest news, shows, and entertainment.
              </p>
            </div>
          </div>
        </div>

        {/* Additional Info Section */}
        <Row className="live-info-section">
          <Col md={4} className="info-card">
            <div className="info-icon">📺</div>
            <h4 className="info-title">24/7 Streaming</h4>
            <p className="info-text">Watch live television anytime, anywhere</p>
          </Col>
          <Col md={4} className="info-card">
            <div className="info-icon">📱</div>
            <h4 className="info-title">Multi-Device</h4>
            <p className="info-text">Stream on your phone, tablet, or computer</p>
          </Col>
          <Col md={4} className="info-card">
            <div className="info-icon">🎬</div>
            <h4 className="info-title">Premium Content</h4>
            <p className="info-text">Enjoy the best African entertainment</p>
          </Col>
        </Row>

        {/* Troubleshooting Section */}
        <div className="troubleshooting-section">
          <h3 className="troubleshooting-title">Having trouble watching?</h3>
          <ul className="troubleshooting-list">
            <li>Make sure you have a stable internet connection</li>
            <li>Try refreshing the page if the stream stops</li>
            <li>Check that your browser supports video playback</li>
            <li>Disable ad blockers that might interfere with the stream</li>
          </ul>
        </div>
      </Container>
    </div>
  )
}

export default Live
